import { Type } from 'class-transformer';
import { IsDefined, IsString, Equals, IsObject, ValidateNested, validate, IsEnum } from 'class-validator';
import { SourceClasses } from '../source-type.interface';
import { ProspectSearchFiltersDto } from './prospect-search/prospect-search-filters.dto';

export class ProspectSearchDto {
    @IsDefined()
    @IsString()
    @IsEnum(SourceClasses)
    class: SourceClasses.PROSPECT_SEARCH;

    @IsDefined()
    @IsObject()
    @ValidateNested()
    config: ProspectSearchFiltersDto;

    constructor(iProspectSearch: ProspectSearchDto) {
        this.class = iProspectSearch.class;
        this.config = new ProspectSearchFiltersDto(iProspectSearch.config);
    }

    static fromDocument(iProspectSearch: ProspectSearchDto) {
        if (!iProspectSearch) return null;
        const prospectSearchFilters = new ProspectSearchDto(iProspectSearch);
        return prospectSearchFilters;
    }
}
